import { combineReducers } from 'redux';

import { notificationBarReducer, NotificationBarState } from './notificationBar';

export interface UIState {
  readonly notificationBar?: NotificationBarState;
}

export const uiReducer = combineReducers<UIState>({
  notificationBar: notificationBarReducer,
});
